import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import Swal from 'sweetalert2';

// Icons
import trash from '../../Assets/AlertIcon/trash.svg';
import audit from '../../Assets/AlertIcon/report-search.svg';
import edit from '../../Assets/AlertIcon/edit.svg';

// Jotai
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  openDeleteKmz,
  selectedKmz,
  selectedDisplayedKmz,
  openUploadKmz,
  partnerNetwork,
  mapMarkersOnSelectedRoute,
  openCostModal,
  selectedRouteOnMap,
  editRoute,
  routeSelection,
  selectedNavRouteAtom,
} from '../../common/atom/atoms';

// Components and functions
import ExportRouteModal from './ExportRouteModal';
import { ExportRoute } from './functions/export_Route.function';

const ITEM_HEIGHT = 48;

export default function RouteAddEditeButtons(props) {
  const { route, setCreateRoutePopup } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openExportModal, setOpenExportModal] = React.useState(false);

  const [selectedKmzIds, setSelectedKmzIds] = useAtom(selectedDisplayedKmz);
  const setOpenDeleteKmz = useSetAtom(openDeleteKmz);
  const [partnerNetworkValue, setPartnerNetwork] = useAtom(partnerNetwork);
  const setSelectedKmz = useSetAtom(selectedKmz);
  const setSelectedRoute = useSetAtom(selectedRouteOnMap);
  const mapMarkersValue = useAtomValue(mapMarkersOnSelectedRoute);
  const setOpenUploadKmz = useSetAtom(openUploadKmz);
  const [openCost, setOpenCost] = useAtom(openCostModal);
  const setEditRoute = useSetAtom(editRoute);

  // For route changing behavior
  const setRouteSelection = useSetAtom(routeSelection);
  const routeOpenAlready = useAtomValue(selectedNavRouteAtom);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleClose();
    setOpenDeleteKmz(true);
    setSelectedRoute(route);
  };

  const handleCostModal = () => {
    if (mapMarkersValue.length > 1) {
      setOpenCost(true);
    } else {
      Swal.fire({
        title: 'Select Route First',
        text: `For adding "Cost" first select area between route`,
        icon: 'info',
        width: '300px',
        height: '300',
        customClass: {
          popup: 'small-swal',
        },
      });
      return;
    }
  };

  const handleEditRoute = () => {
    setEditRoute(true);
    setSelectedRoute(route);
  };

  const handleExportRoute = () => {
    handleClose();
    setOpenExportModal(true);
  };

  const handleExportOption = async (selectedRoute, format) => {
    const response = await ExportRoute(format, selectedRoute?.id);
    let blob;

    if (format === 'geojson') {
      blob = new Blob([JSON.stringify(response, null, 2)], {
        type: 'application/geo+json',
      });
    } else if (format === 'kmz') {
      const uint8Array = new TextEncoder().encode(response);
      blob = new Blob([uint8Array], { type: 'application/vnd.google-earth.kmz' });
    } else {
      console.error('Unsupported format');
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `route_${selectedRoute?.id}.${format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  // 🟢 "Change Route" logic (same as AddRouteButton)
  const handleChangeRoute = () => {
    handleClose();

    if (routeOpenAlready) {
      Swal.fire({
        title: 'Action Not Allowed',
        text: 'Please deselect the current route before proceeding.',
        icon: 'info',
      });
      return;
    }

    if (setCreateRoutePopup) {
      setCreateRoutePopup(true);
    }
    setSelectedRoute(route);
    setRouteSelection(true);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginLeft: '34%' }}>
      <AddCircleOutlineIcon
        sx={{ fontSize: '1rem', color: '#9ea5a7', cursor: 'pointer' }}
        onClick={() => handleCostModal()}
      />

      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
            },
          },
        }}
      >
        <MenuItem disableRipple>
          <GetAppOutlinedIcon style={{ fontWeight: '400', color: '#433f4f' }} />
          <div
            onClick={() => handleExportRoute()}
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Export
          </div>
        </MenuItem>

        <MenuItem disableRipple>
          <img alt="" src={edit} />
          <div
            onClick={() => handleEditRoute()}
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Edit Name
          </div>
        </MenuItem>

        <MenuItem disableRipple>
          <img alt="" src={edit} />
          <div
            onClick={() => handleChangeRoute()}
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Change Route
          </div>
        </MenuItem>

        <MenuItem disableRipple>
          <img alt="" src={audit} />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Audit log
          </div>
        </MenuItem>

        <MenuItem onClick={handleDelete} disableRipple>
          <img alt="" src={trash} />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Delete
          </div>
        </MenuItem>
      </Menu>

      {/* Export Modal */}
      <ExportRouteModal
        open={openExportModal}
        onClose={() => setOpenExportModal(false)}
        route={route}
        onExport={handleExportOption}
      />
    </div>
  );
}
